import PropTypes from 'prop-types';
import { useState } from 'react';

function useOverflowShadows({ stickyFirstColumn = false, stickyLastColumn = false }) {
  if (!stickyFirstColumn && !stickyLastColumn) {
    throw new Error('useOverflowShadows: At least one of stickyFirstColumn or stickyLastColumn must be true.');
  }

  const [leftOverflowShadowOpacity, setLeftOverflowShadowOpacity] = useState(0);
  const [rightOverflowShadowOpacity, setRightOverflowShadowOpacity] = useState(0);

  function onScroll({ scrollFromLeft, scrollFromRight }) {
    setLeftOverflowShadowOpacity(Math.min(scrollFromLeft / 20, 1));
    setRightOverflowShadowOpacity(Math.min(scrollFromRight / 20, 1));
  }

  return {
    stickyFirstColumn,
    stickyLastColumn,
    onScroll,
    styleInfo: {
      firstCell: {
        opacity: leftOverflowShadowOpacity,
      },
      lastCell: {
        opacity: rightOverflowShadowOpacity,
      },
    },
  };
}

useOverflowShadows.propTypes = {
  stickyFirstColumn: PropTypes.bool,
  stickyLastColumn: PropTypes.bool,
};

export const overflowShadowShape = {
  stickyFirstColumn: PropTypes.bool.isRequired,
  stickyLastColumn: PropTypes.bool.isRequired,
  firstHeaderCellRef: PropTypes.object.isRequired,
  lastHeaderCellRef: PropTypes.object.isRequired,
  onScroll: PropTypes.func.isRequired,
  styleInfo: PropTypes.shape({
    firstCell: PropTypes.shape({
      width: PropTypes.number,
      opacity: PropTypes.number,
    }),
    lastCell: PropTypes.shape({
      width: PropTypes.number,
      opacity: PropTypes.number,
    }),
  }).isRequired,
};

export default useOverflowShadows;
